import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import { signIn } from 'aws-amplify/auth';
import './Login.scss';
import giggLogo from '../../../images/gigg-logo.svg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isUserAuthorized, setPageTitle } from '../../../utils/Utils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import variables from '../../../styles/variables.module.scss';

type FieldType = {
  username: string;
  password: string;
};

type ErrorType = {
  name: string;
  message: string;
}

// TODO: Add back in full validation and errors

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm()
  const [error, setError] = useState<ErrorType | undefined>()
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkAuthorization = async () => {
      const isLoggedIn = await isUserAuthorized();

      if (isLoggedIn) {
        navigate('/');
      }
    };

    checkAuthorization();
  }, []);

  useEffect(() => {
    setPageTitle('Register');
  }, []);

  const handleFinish = async (values: FieldType) => {
    const { username, password } = values;
    try {
      setLoading(true);
      await signIn({ username, password });

      if (location.state?.from) {
        navigate(location.state.from);
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(err as ErrorType)
      message.error((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-container justify-center router-wrapper padding-bottom-lg">
      <div className="login-outer">
        <div className="flex-container justify-center">
          <div className="margin-bottom-md">
            <div className="login-image-container">
              <img className="login-img" src={giggLogo} height="auto" width="100%" alt="Gigg" />
            </div>
            <div className="flex-container justify-center">Welcome back! Sign In</div>
          </div>
        </div>
        <div className="login-inner">
          <Form layout="vertical" className="login-form" onFinish={handleFinish} form={form}>
          <Form.Item<FieldType> 
              name="username"
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email'
                },
                {
                  required: true,
                  message: 'Please input your Email'
                }
              ]}
            >
              <Input className="login-input" placeholder="Email" />
            </Form.Item>
            <Form.Item<FieldType> 
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input yout current password'
                }
              ]}
            >
              <Input.Password className="login-input" placeholder="Password" />
            </Form.Item>
            {
              error
              ? <p style={{textAlign: 'center', color: '#ff4d4f' }}>{error.message}</p>
              : null
            }
            <div className="flex-container margin-bottom-md">
              <div className="flex-container flex">
                <Button className="login-button" htmlType="submit" loading={loading}>
                  <span>Sign In</span>
                </Button>
              </div>
            </div>
          </Form>
          <div className="flex-container justify-space-between">
            <Link to="/forgot" className="login-link">
              Forgot your password?
            </Link>
            <div className="signup-cta">
              Don't have an account?{' '}
              <Link to="/register" className="login-link">
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* class SignIn extends React.Component<SignInProps, SignInState> {
  state: SignInState = {
    loading: false,
  };

  componentDidMount() {
    setPageTitle('Sign In');
  }

  onSignIn = (event: any) => {
    // redirect user to previously denied location or to the home page
    const { from } = (this.props.location.state as any) || { from: { pathname: '/' } };
    event.preventDefault();
    this.props.form.validateFields(async (err, fields) => {
      if (!err) {
        this.setState({ error: {} as Error, loading: true });
        Auth.signIn(fields.email.toLowerCase(), fields.password)
          .then(() => {
            this.props.history.push(from);
          })
          .catch((authErr: Error) => {
            this.setState({ error: authErr, loading: false });
          });
      }
    });
  };

  onSignUp = () => {
    this.props.history.push('/register');
  };

  renderError = () => {
    const { error = {} as Error } = this.state;
    if (error.message) {
      if (error.name === 'UserNotConfirmedException') {
        return (
          <Form.Item>
            <div style={{ color: variables.errorColor }} className="text-center">
              {error.message}
              <div>{this.renderVerify()}</div>
            </div>
          </Form.Item>
        );
      }
      return (
        <Form.Item>
          <div style={{ color: '#f5222d', textAlign: 'center' }}>
            {error.message}
            {error.name === 'UserNotConfirmedException' ? this.renderVerify() : ''}
          </div>
        </Form.Item>
      );
    }

    return null;
  };

  onResendEmail = (event: React.MouseEvent) => {
    event.preventDefault();
    this.props.form.validateFields(['email'], async (err, fields) => {
      if (!err) {
        const email = fields.email.toLowerCase();
        this.setState({ error: {} as Error, loading: true });
        Auth.resendSignUp(email)
          .then(() => {
            this.setState({ error: {} as Error, loading: false });
            message.success(`Activation email sent to ${email}`);
          })
          .catch((err: Error) => {
            this.setState({ error: err, loading: false });
          });
      }
    });
  };

  renderVerify = () => {
    const text = 'Resend activation email';
    return (
      <div className="login-link" onClick={this.onResendEmail}>
        {text}
      </div>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="flex-container justify-center router-wrapper padding-bottom-lg">
        <div className="login-outer">
          <div className="flex-container justify-center">
            <div className="margin-bottom-md">
              <div className="login-image-container">
                <img className="login-img" src={giggLogo} height="auto" width="100%" alt="Gigg" />
              </div>
              <div className="flex-container justify-center">Welcome back! Sign In</div>
            </div>
          </div>
          <div className="login-inner">
            <Form layout="vertical" onSubmit={this.onSignIn} className="login-form">
              {this.renderError()}
              <Form.Item>
                {getFieldDecorator('email', {
                  validateTrigger: 'onBlur',
                  rules: [
                    {
                      type: 'email',
                      message: 'Please enter a valid email',
                    },
                    {
                      required: true,
                      message: 'Please input your Email',
                    },
                  ],
                })(<Input className="login-input" placeholder="Email" />)}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator('password', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your current password',
                    },
                  ],
                })(<Input className="login-input" type="password" placeholder="Password" />)}
              </Form.Item>
              <div className="flex-container margin-bottom-md">
                <div className="flex-container flex">
                  <Button className="login-button" htmlType="submit">
                    {this.state.loading ? (
                      <FontAwesomeIcon icon={['fas', 'spinner-third']} size="lg" className="fa-fast-spin" />
                    ) : (
                      <span>Sign In</span>
                    )}
                  </Button>
                </div>
              </div>
            </Form>
            <div className="flex-container justify-space-between">
              <Link to="forgot" className="login-link">
                Forgot your password?
              </Link>
              <div className="signup-cta">
                Don't have an account?{' '}
                <Link to="register" className="login-link">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
} */

export default SignIn;
